import { MediaCategories } from '@cbgms/api'
import { adhocAttachmentWholesalerUUID } from '../utils'
import { SupportMediaParams } from 'app-support/media/state/request'
import { useDispatch } from 'react-redux'
import { useBase64BlobUrl } from 'app-support/media/hooks/use-build-base64-blob-url'
import { getPrivateMediaItem } from 'app-support/media/state/actions'

type buildMediaItemUrl = (fileName: string, companyUUID: string) => Promise<string>

export function useBuildMediaItemUrl(): buildMediaItemUrl {
  const dispatch = useDispatch()
  const buildBlobURL = useBase64BlobUrl()
  const buildMediaItemUrl = async (fileName: string, companyUUID: string): Promise<string> => {
    const SupportMediaParams: SupportMediaParams = {
      category: MediaCategories.AdhocAttachments,
      companyUUID,
      subCategory: adhocAttachmentWholesalerUUID,
      fileName
    }
    const { Data } = await dispatch(getPrivateMediaItem(SupportMediaParams))
    return buildBlobURL(Data.Data, Data.ContentType)
  }

  return buildMediaItemUrl
}
